"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.existsWithin = void 0;
var is_object_1 = require("./is-object");
function existsWithin(item1, item2) {
    if (!(0, is_object_1.isObject)(item2)) {
        return false;
    }
    return Object.entries(item1).every(function (_a) {
        var key = _a[0], value = _a[1];
        if ((0, is_object_1.isObject)(value)) {
            return existsWithin(value, item2[key]);
        }
        return value === item2[key];
    });
}
exports.existsWithin = existsWithin;
